// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardSection_EUNbA {
  border-top: 1px solid var(--color-base050);
  padding: var(--size-padLarge);
}

.cardSection_EUNbA:first-child {
  border-top: none;
}

.sectionTitle_DMCEo {
  margin-bottom: 10px;
}

.button_LJCAR {
  cursor: pointer;
}

.codes_KNCSx {
  background-color: var(--color-base050);
  font-family: monospace;
}

.code_liDtT {
  width: 25%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-login/lib/twoFactor/TwoFactorScreen.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".cardSection {\n  border-top: 1px solid var(--color-base050);\n  padding: var(--size-padLarge);\n}\n\n.cardSection:first-child {\n  border-top: none;\n}\n\n.sectionTitle {\n  margin-bottom: 10px;\n}\n\n.button {\n  cursor: pointer;\n}\n\n.codes {\n  background-color: var(--color-base050);\n  font-family: monospace;\n}\n\n.code {\n  width: 25%;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardSection": `cardSection_EUNbA`,
	"sectionTitle": `sectionTitle_DMCEo`,
	"button": `button_LJCAR`,
	"codes": `codes_KNCSx`,
	"code": `code_liDtT`
};
export default ___CSS_LOADER_EXPORT___;
